import { makeStyles } from 'tss-react/mui';

const useFilterChipStyles = makeStyles()((theme) => ({
  container: {
    border: `1px solid ${theme.palette.custom.border.primary}`,
    backgroundColor: theme.palette.secondary.main,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    height: 24,
    flexShrink: 0,
    alignItems: 'center',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '& .MuiButton-root:hover': {
      backgroundColor: 'transparent',
    },
  },
  insetStart: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(0.5),
  },
  insetEnd: {
    paddingRight: theme.spacing(1),
  },
  actionButton: {
    borderRadius: 0,
    padding: theme.spacing(0, 0.25),
    height: '100%',
  },
  rotated: {
    transform: 'rotate(180deg)',
    transition: 'transform 0.2s',
  },
  labelWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    whiteSpace: 'nowrap',
  },
}));

export default useFilterChipStyles;
